import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Token pro Request aus dem zustand-persist holen und als Header setzen
api.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem("auth-storage");
    if (raw) {
      const { state } = JSON.parse(raw);
      const token = state?.token;
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
  } catch {}
  return config;
});

// 401s automatisch mit Refresh-Token auffangen
let refreshPromise = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error?.config || {};
    const status = error?.response?.status;

    const shouldSkipRefresh =
      originalRequest?._skipAuthRefresh ||
      !status ||
      status !== 401 ||
      originalRequest?.__isRetryRequest ||
      (originalRequest?.url && originalRequest.url.includes("/auth/refresh"));

    if (shouldSkipRefresh) {
      return Promise.reject(error);
    }

    try {
      if (!refreshPromise) {
        refreshPromise = (async () => {
          const { default: useAuthStore } = await import("../store/authStore");
          return useAuthStore.getState().refreshSession();
        })();
      }

      const newAccessToken = await refreshPromise;
      originalRequest.__isRetryRequest = true;
      originalRequest.headers = originalRequest.headers || {};
      originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
      return api(originalRequest);
    } catch (refreshError) {
      try {
        const { default: useAuthStore } = await import("../store/authStore");
        useAuthStore.getState().logout();
      } catch (logoutError) {
        console.error("Failed to logout after refresh failure:", logoutError);
      }
      return Promise.reject(refreshError);
    } finally {
      refreshPromise = null;
    }
  }
);

export default api;
